import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Context
const RezerwyPaginationContext = createContext();

// Custom Hook to use the Pagination Context
export const usePaginationRezerwy = () => {
  const context = useContext(RezerwyPaginationContext);
  if (!context) {
    throw new Error('usePaginationRezerwy must be used within a PaginationProviderRezerwy');
  }
  return context;
};

// PaginationProvider Component
export const PaginationProviderRezerwy = ({ children }) => {
  const [pagination, setPagination] = useState({
    current: JSON.parse(localStorage.getItem('currentPageMSRRezerwy')) || 1,
    pagesize: JSON.parse(localStorage.getItem('MSRPagesizeRezerwy')) || 20,
    loading: false,
    generated: false,
    search: JSON.parse(localStorage.getItem('searchRezerwy')) || null,
    advancedSearch: JSON.parse(localStorage.getItem('advancedSearchMSRRezerwy')) || null,
    orderby: [],
    reload: false,
  });

  // Update localStorage whenever pagination state changes
  useEffect(() => {
    localStorage.setItem('currentPageMSRRezerwy', JSON.stringify(pagination.current));
    localStorage.setItem('advancedSearchMSRRezerwy', JSON.stringify(pagination.advancedSearch));
    localStorage.setItem('MSRPagesize', JSON.stringify(pagination.pagesize));
    localStorage.setItem('searchRezerwy', JSON.stringify(pagination.search));
  }, [pagination]);

  return (
    <RezerwyPaginationContext.Provider value={{ pagination, setPagination }}>
      {children}
    </RezerwyPaginationContext.Provider>
  );
};
